//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import productPreviewModeMixin from '@motionelements/product2025/src/mixins/product-preview-mode.mixin.js';

export default {
  name: 'CtaButtons',
  components: {
    AddToCartButton: () => import('@motionelements/product2025/src/components/buttons/AddToCartButton.vue'),
    DownloadButton: () => import('@motionelements/product2025/src/components/buttons/DownloadButton.vue'),
  },
  mixins: [productPreviewModeMixin],
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      isDownloadableDirectly: 'product/isDownloadableDirectly',
    }),
  },
};
